// base
import React, { useEffect } from 'react';

// hooks
import { useIconControl } from 'hooks';

// libraries
import gsap from 'gsap';
import { useGLTF } from '@react-three/drei'

useGLTF.preload('/assets/models/icons/success_shield/success_shield.gltf');

export const SuccessShield = (props) => {
  const { onClick, ...rest } = props;

  const { scene, nodes, materials } = useGLTF(
    '/assets/models/icons/success_shield/success_shield.gltf'
  );
  const { hovered, setHovered, iconRef } = useIconControl({
    onClick
  })


  useEffect(() => {
    scene.traverse((mesh) => {
      mesh.castShadow = true;
      mesh.receiveShadow = true;
    });

    if (!iconRef.current) return;

    const rotationTween = gsap.to(iconRef.current.rotation, {
      duration: 3,
      repeat: -1,
      yoyo: false,
      ease: 'none',
      y: Math.PI * 2,
    });

    return () => {
      rotationTween.kill();
    };
  }, []);

  useEffect(() => {
    if (!iconRef.current) return;

    gsap.to(iconRef.current.scale, {
      duration: 0.5,
      x: hovered ? 1.5 : 1,
      y: hovered ? 1.5 : 1,
      z: hovered ? 1.5 : 1
    });
  }, [hovered]);

  return (
    <group
      {...rest}
      dispose={null}
      ref={iconRef}
      scale={[1, 1, 1]}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
      onPointerDown={onClick}
    >
      <group position={[0, 56.154, 0]}>
        <mesh
          geometry={nodes.shield_v1.geometry}
          material={materials.color}
          rotation={[-Math.PI / 2, 0, 0]}
        />
      </group>
    </group>
  );
};
